// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"page_noScrolling__Ywk9Q","marquee":"page_marquee__NYKz4","stat":"page_stat__UjiuZ","statTitle":"page_statTitle__5Zxe0","statData":"page_statData__iG0NA"};